/**
 * @generated SignedSource<<d031cd22363bd582cecc266a8c2032a0>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { InlineFragment, ReaderInlineDataFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type getShoppablePhotoData_tradePhoto$data = {
  readonly creators: ReadonlyArray<{
    readonly " $fragmentSpreads": FragmentRefs<"getShoppablePhotoData_creators">;
  } | null> | null;
  readonly tags: ReadonlyArray<{
    readonly " $fragmentSpreads": FragmentRefs<"getShoppablePhotoData_tags">;
  } | null> | null;
  readonly " $fragmentType": "getShoppablePhotoData_tradePhoto";
};
export type getShoppablePhotoData_tradePhoto$key = {
  readonly " $data"?: getShoppablePhotoData_tradePhoto$data;
  readonly " $fragmentSpreads": FragmentRefs<"getShoppablePhotoData_tradePhoto">;
};

const node: ReaderInlineDataFragment = {
  "kind": "InlineDataFragment",
  "name": "getShoppablePhotoData_tradePhoto"
};

(node as any).hash = "150df1def2341a21a6e1a6c6069dd5ac";

export default node;
